<section
  class="flex flex-col items-center gap-6 rounded-lg bg-greyscale-50 py-12"
>
  <i
    class="pi pi-exclamation-circle rounded-full bg-primary-100 p-4"
    style="font-size: 2rem; color: var(--color-primary-500)"
  ></i>
  <div class="flex flex-col items-center gap-4">
    <h4 class="text-primary-900">
      {{ title }}
    </h4>
    <p class="text-center text-paragraph-s-reg text-greyscale-500">
      {{ text }}
    </p>
    <p-button [label]="buttonLabel" variant="outlined" (click)="action()" />
  </div>
</section>
